export default class Module {
	constructor(el) {
		//-- Properties
		//--------------------------------------------------------------
		this.dom = {
			el: el,
			body: $('body'),
			html: $('html'),
			page: $('html, body'),
			site: $('#site'),
			w: $(window),
		};
	}

	//-- Methods
	//--------------------------------------------------------------
	backToTop() {
		this.dom.page.animate({ scrollTop: 0 }, 500);
	}

	manageAuthentication() {
		if (window.cirqueClub.isAuthenticated) {
			this.dom.site.find('.hidden-anonymous').removeClass('hidden-anonymous');
		} else {
			this.dom.site.find('.hidden-logged').removeClass('hidden-logged');
		}
	}
}
